import React from 'react';
import { Link } from 'react-router-dom';

function Error() {
    return (
        <div className="container">
            <div className="error">
                <img alt="error" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/Erorr.png" />
                <br />
                操作錯誤！
                <Link to="/">點此返回</Link>
            </div>
        </div>
    );
}

export default Error;


// WEBPACK FOOTER //
// ./src/containers/Error.jsx